import { apiCall } from "utils/apiClient";
export async function packageRequest(endpoint, method = "GET", data = null, params = null) {
  const response = await apiCall({ endpoint, method, data, params });
  if (![200, 201].includes(Number(response?.status))) throw new Error(response?.message || response?.messages?.error || "Request failed. Please try again.");
  return response.data;
}
export const packagePath = (id) => `admin/packages/${id}`;
export const isArea = (unit) => ["sqft", "square_feet"].includes(unit);
export const flag = (value) => [true, 1, "1"].includes(value);
export const unitLabel = (unit) => String(unit || "unit").replaceAll("_", " ");
// Keep the legacy dashboard's max-content input overrides inside these forms.
export const packageFieldsSx = {
  "& .MuiFormControl-root": { minWidth: 0, width: "100%" },
  "& .MuiInputBase-root": { minWidth: 0, width: "100% !important", display: "flex !important" },
  "& .MuiInputBase-input": { minWidth: 0, width: "100% !important", boxSizing: "border-box" },
  "& .MuiInputLabel-root": { fontSize: 14, maxWidth: "calc(100% - 24px)" },
};
export const imageUrl = (source) => !source ? "" : /^https?:\/\//i.test(source) ? source : `${String(process.env.REACT_APP_HAPS_MAIN_BASE_URL || "http://localhost:8080/").replace(/\/$/, "")}/${String(source).replace(/^\//, "")}`;
